module.exports = {
  profile: {
    descriptions: {
      name: "name",
      birthdate: "birthday",
      email: "email address",
      msisdn: "Maya mobile number",
      contact: "contact details",
      sourceoffunds: "source of funds",
      natureofwork: "nature of work",
      address: "full address",
      kycid: "copy of valid ID",
      kycselfie: "photo of video selfie",
    },
  },
}
